import { Controller } from "@hotwired/stimulus"
import { notifyOfflineWrite, writeFetch } from "./sweeper_shared"

export default class extends Controller {
  static values = {
    frameId: String,
    url: String
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  schedule() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.save(), 500)
  }

  async save() {
    clearTimeout(this.timeout)
    const response = await writeFetch(this.urlValue, {
      method: "PATCH",
      credentials: "include",
      headers: this.headers,
      body: JSON.stringify({ notes: this.element.value })
    })

    if (!response.ok) return notifyOfflineWrite()

    this.dispatchSessionUpdated(await response.json())
    if (document.activeElement !== this.element) this.reloadFrame()
  }

  get headers() {
    return {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
    }
  }

  dispatchSessionUpdated(session) {
    document.dispatchEvent(new CustomEvent("sweeper:session-updated", { detail: { session } }))
  }

  reloadFrame() {
    const frame = document.getElementById(this.frameIdValue)
    if (frame && typeof frame.reload === "function") frame.reload()
  }
}
